export const nltoBr = (str) =>
  (str ? str.replace(/(?:\r\n|\r|\n)/g, '<br />') : '')

export const capitalize = (str) => (
  `${str.charAt(0).toUpperCase()}${str.slice(1)}`
)
